import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Receipt, SlidersHorizontal, LogOut, Monitor, Timer, ChevronRight } from "lucide-react";
import { apiCall } from "../admin/calendar/calendarUtils";
import { PushSettings } from "./PushSettings";

function IdleCard({ token }) {
  const [v, setV] = useState(30);
  useEffect(() => { apiCall(token, "/app/admin/settings").then((d) => setV(d.idle_minutes)).catch(() => {}); }, [token]);
  const save = async (val) => {
    setV(val);
    try { await apiCall(token, "/app/admin/settings", { method: "PUT", body: { idle_minutes: Number(val) } }); toast.success("Automatische Abmeldung gespeichert"); } catch (e) { toast.error(e.message); }
  };
  return (
    <div className="bg-[#121212] border border-white/10 p-4 flex items-center justify-between gap-3" data-testid="idle-card">
      <span className="flex items-center gap-2 text-white text-sm"><Timer className="w-5 h-5 text-[#71717A]" />Automatisch abmelden nach</span>
      <select value={v} onChange={(e) => save(e.target.value)} className="h-10 px-2 bg-[#0A0A0A] border border-white/20 text-white" data-testid="idle-select">
        {[15, 30, 60, 120, 240, 480].map((m) => <option key={m} value={m}>{m < 60 ? `${m} Min` : `${m / 60} Std`}</option>)}
      </select>
    </div>
  );
}

const Item = ({ icon: Icon, label, onClick, testId }) => (
  <button type="button" onClick={onClick} className="w-full flex items-center gap-3 bg-[#121212] border border-white/10 p-4 text-white active:bg-white/5" data-testid={testId}>
    <Icon className="w-5 h-5 text-[#c1ff72]" /><span className="flex-1 text-left">{label}</span><ChevronRight className="w-4 h-4 text-[#71717A]" />
  </button>
);

export function MoreView({ token, go, onLogout }) {
  return (
    <div className="space-y-3" data-testid="mobile-more">
      <Item icon={Receipt} label="Rechnungen & Buchhaltung" onClick={() => go("invoices")} testId="more-invoices" />
      <Item icon={SlidersHorizontal} label="Verfügbarkeiten & Buchungsregeln" onClick={() => go("rules")} testId="more-rules" />
      <h2 className="pt-3 text-xs uppercase tracking-widest text-[#71717A]" data-testid="settings-heading">Einstellungen</h2>
      <PushSettings token={token} />
      <IdleCard token={token} />
      <Item icon={Monitor} label="Vollständigen Admin-Bereich öffnen" onClick={() => { window.location.href = "/admin"; }} testId="more-desktop" />
      <button type="button" onClick={onLogout} className="w-full flex items-center justify-center gap-2 h-12 border border-red-500/40 text-red-300" data-testid="more-logout"><LogOut className="w-4 h-4" />Abmelden</button>
    </div>
  );
}
